import { AfterViewInit, Component, Input } from '@angular/core';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-loading-indicator',
  templateUrl: './loading-indicator.component.html',
  styleUrls: ['./loading-indicator.component.scss']
})
export class LoadingIndicatorComponent implements AfterViewInit{
  @Input() public textWhileLoading = '';

  public loading!: boolean;

  public constructor(private loaderService: LoaderService) { 
  }

  public ngAfterViewInit() {
    Promise.resolve(() => {
      this.loaderService.isLoading$.subscribe((isLoading: boolean) => {
        this.loading = isLoading;
      });
    });
  } 
}
